/* 
 * CALS Bind Logs for dev 
 */
import { localStorageAPI } from './desertland.service';
// var DESERTLAND = require("./desertland.init"),
    // Service = require("./desertland.service");

const devReq = 'please';
    
export default function DevLogBind (cmd, opts) {
   //here's some dev functions - for our devs
    
    //DESERTLAND.dev = (function (cmd, opts) {
        // tslint:disable-next-line:no-shadowed-variable
        // return function(cmd, opts) {// eslint-disable-line no-shadow
            let msg = "hello.";
            const noop = function () {};
            switch(cmd) {
                case 'disableLogs':
                    window.log = noop;
                    window.info = noop;
                    window.warn = console.warn.bind(console);
                    window.error = console.error.bind(console);
                    window.group = noop;
                    window.groupCollapsed = noop;
                    window.groupEnd = noop;
                    window.time = noop;
                    window.timeEnd = noop;
                    
                    msg = "dev logs disable.d";
                    if (!opts || opts !== true) {
                        localStorageAPI.save("consoul", "0", false);
                        msg += "... & saved.";
                    }
                    break;
                    
                    
                case 'enableLogs':
                    if (opts === devReq) {
                        window.log = console.log.bind(console);
                        window.info = console.info.bind(console);
                        window.warn = console.warn.bind(console);
                        window.error = console.error.bind(console);
                        window.group = console.group.bind(console);
                        window.groupCollapsed = console.groupCollapsed.bind(console);
                        window.groupEnd = console.groupEnd.bind(console);
                        window.time = console.time.bind(console);
                        window.timeEnd = console.timeEnd.bind(console);
                        
                        
                        localStorageAPI.save("consoul", "1", false);
                        msg = "dev logs enable.d";
                    } else {
                        msg = "you didn't say the magic word...";
                    }
                    break;
            }
            return msg;
        // };
    //})();

}
